import React from 'react';

class LandmarksView extends React.Component {

    render() {
        const hotel = this.props.hotel;
        const landmarks = [];
        hotel.landmarks.forEach((landmark) => {
            landmarks.push(
                <tr>
                    <td>{landmark.name}</td>
                    <td>{landmark.distance}</td>
                </tr>
            );
        });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="hotel-detail-subhead">
                            Surroundings and Landmarks
                        </h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">Landmark</th>
                                    <th scope="col">Distance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {landmarks}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default LandmarksView


// WEBPACK FOOTER //
// src/routes/hotels/components/LandmarksView.js